"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerWidget = void 0;
var tslib_1 = require("tslib");
/* eslint-disable import/no-cycle */
var React = tslib_1.__importStar(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var AutoFocus_1 = require("../../utils/AutoFocus");
var Date_1 = require("../../utils/Date");
var DomUtil_1 = require("../../utils/DomUtil");
var CarouselWidget_1 = require("./CarouselWidget");
var DatePickerBody_1 = require("./DatePickerBody");
var DatePickerDayOfWeekHeader_1 = require("./DatePickerDayOfWeekHeader");
var DatePickerStyles_1 = require("./DatePickerStyles");
var DatePickerWidget = /** @class */ (function (_super) {
    tslib_1.__extends(DatePickerWidget, _super);
    function DatePickerWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerId = DomUtil_1.generateId();
        _this.gridDomRef = React.createRef();
        _this.state = {
            focusedDate: _this.props.selectedDate || new Date(),
        };
        _this.handleOnConfirm = function (date) {
            var _a, _b;
            (_b = (_a = _this.props).onConfirm) === null || _b === void 0 ? void 0 : _b.call(_a, date);
        };
        _this.handleOnChange = function (date) {
            var _a;
            if (_this.props.onChange && date.getTime() !== ((_a = _this.props.selectedDate) === null || _a === void 0 ? void 0 : _a.getTime())) {
                _this.props.onChange(date);
            }
        };
        _this.handleFocusedDateChange = function (date) {
            _this.setState({ focusedDate: date });
        };
        _this.handleClickPrevMonth = function () {
            _this.handleFocusedDateChange(Date_1.getDateWithMonthOffset(_this.state.focusedDate, -1));
        };
        _this.handleClickNextMonth = function () {
            _this.handleFocusedDateChange(Date_1.getDateWithMonthOffset(_this.state.focusedDate, 1));
        };
        return _this;
    }
    DatePickerWidget.prototype.componentDidMount = function () {
        if (this.props.autofocus) {
            AutoFocus_1.autoFocus(false, this.gridDomRef.current, false);
        }
    };
    DatePickerWidget.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.selectedDate !== this.props.selectedDate) {
            this.setState({ focusedDate: this.props.selectedDate || new Date() });
        }
    };
    DatePickerWidget.prototype.getDisplayedMonthAndYear = function () {
        return Localize_1.Formatters.formatFullMonthAndFullYear(this.state.focusedDate);
    };
    DatePickerWidget.prototype.render = function () {
        return React.createElement("div", { style: DatePickerStyles_1.datePickerWidgetStyle, "data-tb-test-id": this.props.testId },
            React.createElement(CarouselWidget_1.CarouselWidget, { id: this.headerId, nextButtonTitle: Localize_1.Messages.nextMonth(), onNextClick: this.handleClickNextMonth, onPreviousClick: this.handleClickPrevMonth, prevButtonTitle: Localize_1.Messages.previousMonth(), role: 'heading', style: DatePickerStyles_1.datePickerHeaderStyle }, this.getDisplayedMonthAndYear()),
            React.createElement("div", { "aria-labelledby": this.headerId, role: 'grid', ref: this.gridDomRef },
                React.createElement(DatePickerDayOfWeekHeader_1.DatePickerDayOfWeekHeader, { showWeekNumbers: this.props.showWeekNumbers }),
                React.createElement(DatePickerBody_1.DatePickerBody, { focusedDate: this.state.focusedDate, isDateDisabled: this.props.isDateDisabled, onChange: this.handleOnChange, onConfirm: this.handleOnConfirm, onFocusedDateChange: this.handleFocusedDateChange, selectedDate: this.props.selectedDate, showWeekNumbers: !!this.props.showWeekNumbers })));
    };
    return DatePickerWidget;
}(React.PureComponent));
exports.DatePickerWidget = DatePickerWidget;
//# sourceMappingURL=DatePickerWidget.js.map